import { Wrap, WrapItem } from '@chakra-ui/react'

import { getPartnerLogoURL } from '@/client/services/url'

import OptimizedImage from '@/components/PublicImage/OptimizedImage'
import ShwLink from '@/components/ShwLink'

const PRESS_PARTNERS: {
  logoSrc: string
  href: string
  name: string
  logoWidth: number
  logoHeight: number
}[] = [
  {
    href: 'https://www.nytimes.com/2020/08/13/opinion/coronavirus-school-digital.html',
    logoSrc: 'NYT.png',
    logoWidth: 337,
    logoHeight: 63,
    name: 'The New York Times',
  },
  {
    href: 'https://www.usatoday.com/story/opinion/2021/02/17/education-improve-after-pandemic-covid-charter-school-individualized-column/6712875002/',
    logoSrc: 'USATODAY.png',
    logoWidth: 362,
    logoHeight: 67,
    name: 'USA Today',
  },
  {
    href: 'https://www.csmonitor.com/USA/Education/2021/0316/The-tutoring-revolution-How-it-could-transform-education',
    logoSrc: 'CSM-v2.png',
    logoWidth: 188,
    logoHeight: 51,
    name: 'The Christian Science Monitor',
  },
  {
    href: 'https://www.latimes.com/california/story/2023-08-31/caltech-drops-calculus-chemistry-physics-class-admission-requirements-for-some',
    logoSrc: 'la-times-logo.svg',
    logoWidth: 337,
    logoHeight: 42,
    name: 'The Los Angeles Times',
  },
]

export default function PressPartners() {
  return (
    <Wrap spacing="24px" display={['none', 'none', 'flex']} align="center">
      {PRESS_PARTNERS.map(({ logoSrc, href, name, logoWidth, logoHeight }) => (
        <WrapItem key={logoSrc}>
          <ShwLink variant="unstyled" href={href} key={logoSrc}>
            <OptimizedImage
              src={getPartnerLogoURL(logoSrc)}
              originalWidth={logoWidth}
              originalHeight={logoHeight}
              displayWidth="120px"
              alt={name}
            />
          </ShwLink>
        </WrapItem>
      ))}
    </Wrap>
  )
}
